// extracted by mini-css-extract-plugin
module.exports = {"loader":"appLoader_loader__wyrcn","spin":"appLoader_spin__PgO2p","appOverlay":"appLoader_appOverlay__2C2tK"};